import * as React from "react";
import { PlayerFragmentFragment } from "../../../graphql/PlayerFragment.generated";
import { SystemMessageContentFragmentFragment } from "../../../graphql/ActivityFragment.generated";

//A message from the platform: no sender, the feed shows the platform logo instead of an avatar
export const SystemMessageActivity = ({
  content,
}: {
  actor: PlayerFragmentFragment | null;
  content: SystemMessageContentFragmentFragment;
  openProfile: () => void;
  setRead: () => void;
}) => <div className="text-sm whitespace-pre-line">{content.message}</div>;
